import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { catalogueItem } from "assets/types";
import { getCatalogue } from "utils/getCatalogue";

const initialState: Array<catalogueItem> = getCatalogue();

export const catalogueSlice = createSlice({
  name: "catalogue",
  initialState,
  reducers: {
    add: (state, action: PayloadAction<catalogueItem>) => {
      return (state = [...state, action.payload]);
    },
    remove: (state, action: PayloadAction<catalogueItem>) => {
      return (state = state.filter(
        (el) => el.barcode !== action.payload.barcode
      ));
    },
    update: (state, action: PayloadAction<catalogueItem>) => {
      let index = state.findIndex(
        (el) => el.barcode === action.payload.barcode
      );
      let result = [...state];

      result.splice(index, 1, action.payload);
      return (state = result);
    },
    set: (state, action: PayloadAction<Array<catalogueItem>>) => {
      return (state = action.payload);
    },
  },
});

export const { add, remove, update, set } = catalogueSlice.actions;
export default catalogueSlice.reducer;
